/**
 * TODO Move this to scanner.ts. This was explicitly not to to avoid a large PR polluting other work.
 * The remainder of scanner.js was moved to scanner.ts easily and everything passed lint.
 */
export const scannerMessages = {
  GET_AVAILABLE_DEVICES: "get_available_devices",
  NEW_SCAN: "new_scan",
  CONNECTION_STATUS: "connection_status",
  CONNECT_TO_DEVICE: "connect_to_device",
  DISCONNECT_FROM_DEVICE: "disconnect_from_device",
  START_DRAFT: "start_draft",
  RESEND_SCAN: "resend_scan",
  READ_SAVED_SCANS: "read_saved_scans",
  CANCEL_READ_SAVED_SCANS: "cancel_read_saved_scans",
  ERASE_SAVED_SCANS: "erase_saved_scans",
  UPDATE_DEVICE_TIME: "update_device_time",
  READ_DEVICE_TIME: "read_device_time",
  PING_FROM_APP: "ping_from_app",
  AVAILABLE_DEVICES: "available_devices",
  SAVED_SCANS: "saved_scans",
  DEVICE_TIME: "device_time",
  PRINT_RECEIPT: "print_receipt",
  MESSAGE: "message",
  LIST_WEIGHING_SESSIONS: "list_weighing_sessions",
  WEIGHING_SESSIONS: "weighing_sessions",
  READ_WEIGHING_SESSION: "read_weighing_session",
  WEIGHING_SESSION: "weighing_session",
};
